import React from "react";

const Testimonials = () => {
  const testimonials = [
    {
      quote:
        "I used to spend hours setting up backend forms for client projects in Kolkata. ContactHQ lets me create forms in minutes and focus on coding instead of PHP mailers.",
      name: "Anirban Das",
      role: "Full Stack Developer, Kolkata",
      mood: "star",
    },
    {
      quote:
        "Managing handicraft inquiries from Jaipur was a nightmare. Now, every customer message lands in one shared inbox. It’s a massive productivity booster for our team.",
      name: "Vikram Singh",
      role: "Business Owner, Jaipur",
      mood: "favorite",
    },
    {
      quote:
        "Managing multiple client forms across Delhi was chaotic. Now, we track responses and collaborate without ever touching a spreadsheet. Highly recommended for agencies.",
      name: "Sayani Verma",
      role: "Digital Marketing Head, Delhi",
      mood: "rocket_launch",
    },
    {
      quote:
        "Collecting registrations for our cultural events in Siliguri has never been simpler. The dashboard is clean, and my team loves the easy tagging system.",
      name: "Pritam Ghosh",
      role: "Event Coordinator, West Bengal",
      mood: "celebration",
    },
    {
      quote:
        "ContactHQ handles our sign-ups and demo requests perfectly. For a growing startup in Jodhpur, this centralized inbox is an absolute game-changer.",
      name: "Rajesh Meena",
      role: "SaaS Founder, Rajasthan",
      mood: "bolt",
    },
    {
      quote:
        "The shared inbox keeps our e-commerce communications organized. It helps our Delhi-based support team make much faster and smarter decisions.",
      name: "Vedika Kapoor",
      role: "E-commerce Manager, Delhi",
      mood: "insights",
    },
  ];

  return (
    <section
      id="testimonials"
      className="py-16 sm:py-20 lg:py-24 bg-[#F8FAFC] overflow-hidden border-t border-[#E2E8F0]"
    >
      <div className="mx-auto w-[95%] md:w-[90%]">
        {/* HEADER */}
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-16 animate-fade-in-up">
          <h2 className="text-sm sm:text-base font-bold tracking-[0.2em] text-[#E63946] uppercase mb-3 sm:mb-4">
            User Feedback
          </h2>
          <h3 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0B1C2D] lg:text-5xl mb-4 sm:mb-6">
            Real Stories from{" "}
            <span className="text-[#E63946]">Real Users.</span>
          </h3>
          <p className="text-base sm:text-lg text-[#64748B]">
            At ContactHQ, we help teams and freelancers across India stay
            organized. Hear from the people using it every day.
          </p>
        </div>

        {/* UNIFORM GRID TESTIMONIALS */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="group relative flex flex-col h-full p-6 sm:p-8 rounded-3xl bg-white border border-[#E2E8F0] shadow-sm hover:shadow-2xl hover:border-[#E63946]/30 hover:-translate-y-2 transition-all duration-500 opacity-0 animate-fade-in-up"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {/* Mood Indicator / Icon */}
              <div className="flex justify-between items-start mb-6">
                <div className="size-10 rounded-full bg-slate-50 flex items-center justify-center text-[#E63946] group-hover:bg-[#E63946] group-hover:text-white transition-colors duration-300">
                  <span className="material-symbols-outlined text-xl">
                    {item.mood}
                  </span>
                </div>
                <div className="flex gap-0.5 text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <span
                      key={i}
                      className="material-symbols-outlined text-sm fill-current"
                    >
                      star
                    </span>
                  ))}
                </div>
              </div>

              {/* Quote - flex-grow ensures the bottom section stays aligned */}
              <blockquote className="flex-grow text-base sm:text-lg font-medium text-[#0B1C2D] leading-relaxed mb-8">
                "{item.quote}"
              </blockquote>

              {/* User Identity - Pushed to the bottom */}
              <div className="flex items-center gap-4 pt-6 border-t border-[#F1F5F9] mt-auto">
                <div className="relative">
                  <img
                    src={`https://i.pravatar.cc/100?u=${item.name}`}
                    alt={item.name}
                    className="size-12 rounded-full border-2 border-white shadow-sm grayscale group-hover:grayscale-0 transition-all duration-500"
                  />
                  <div className="absolute -bottom-1 -right-1 size-4 bg-green-500 border-2 border-white rounded-full"></div>
                </div>
                <div>
                  <p className="text-sm font-bold text-[#0B1C2D]">
                    {item.name}
                  </p>
                  <p className="text-[11px] font-medium text-[#64748B] uppercase tracking-wider">
                    {item.role}
                  </p>
                </div>
              </div>

              {/* Background Micro-Glow on Hover */}
              <div className="absolute inset-0 -z-10 bg-gradient-to-br from-transparent to-transparent group-hover:from-[#E63946]/5 group-hover:to-transparent rounded-3xl transition-all duration-500"></div>
            </div>
          ))}
        </div>

        {/* BOTTOM CTA */}
        <div className="mt-20 text-center animate-fade-in-up [animation-delay:800ms]">
          <div className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#0B1C2D] rounded-full text-white text-sm font-bold hover:bg-[#E63946] transition-all duration-300 cursor-pointer shadow-xl shadow-[#0B1C2D]/20 group">
            Join 100+ happy users
            <span className="material-symbols-outlined text-sm group-hover:translate-x-1 transition-transform">
              arrow_forward
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
